import Axios from "axios";
const apiClient = Axios.create({
  baseURL: "https://api.openweathermap.org/data/2.5",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-type": "application/json"
  }
});

export default {
  async getHourly(position) {
    let lat = 0;
    let lon = 0;
    if (position) {
      lat = position.coords.latitude;
      lon = position.coords.longitude;
    }

    return apiClient.get("/onecall", {
      params: {
        lat: lat,
        lon: lon,
        exclude: "minutely,daily,current",
        units: "imperial",
        appid: "09c98fd10123ca0d3d963755f91da89c"
      }
    });
  },
  async getWeather(position) {
    let lat = 0;
    let lon = 0;
    if (position) {
      lat = position.coords.latitude;
      lon = position.coords.longitude;
    }

    return apiClient.get("/onecall", {
      params: {
        lat: lat,
        lon: lon,
        exclude: "minutely,hourly",
        units: "imperial",
        appid: "09c98fd10123ca0d3d963755f91da89c"
      }
    });
  },

  getCoordinates() {
    return new Promise(function(resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }
};
